import { render, staticRenderFns } from "./TempAssets.vue?vue&type=template&id=5703b9da&scoped=true&"
import script from "./TempAssets.vue?vue&type=script&lang=js&"
export * from "./TempAssets.vue?vue&type=script&lang=js&"
import style0 from "./TempAssets.vue?vue&type=style&index=0&id=5703b9da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5703b9da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5703b9da')) {
      api.createRecord('5703b9da', component.options)
    } else {
      api.reload('5703b9da', component.options)
    }
    module.hot.accept("./TempAssets.vue?vue&type=template&id=5703b9da&scoped=true&", function () {
      api.rerender('5703b9da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/temp-assets/TempAssets.vue"
export default component.exports